export const ROUTES = {
    AGENCY: '/agency',
    CAREERS: '/careers',
    CAREERS_APPLY: '/careers/apply',
    HOME: '/',
    PROJECT: '/projects/:slug',
    PROJECTS: '/projects',
    LOGIN: '/login',
    CONTACT: {
        MAIN: '/contact',
        SEND_MESSAGE: '/contact/send-message',
    },
};
